export const CALL_INSIGHTS_FF = 'call-history:enable-call-insights';
